/** Keep the introduction anchor in sync with populated help sections. */
class MindAnchor extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.schedule = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.updateTarget());
    };
    this.observer?.disconnect();
    this.observer = new MutationObserver(this.schedule);
    this.observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    for (const event of ['DOMContentLoaded', 'shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
      document.addEventListener(event, this.schedule, { signal: this.controller.signal });
    }
    this.schedule();
  }

  updateTarget() {
    if (!this.isConnected) return;
    const link = this.querySelector('a');
    if (!link) return;
    const target = document.querySelector('[data-mind-help]');
    link.hidden = !target;
    if (target) link.setAttribute('href', `#${target.id}`);
    else link.removeAttribute('href');
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('bm-mind-anchor')) customElements.define('bm-mind-anchor', MindAnchor);
